/**
 * Format a number for display as a percentage.
 * Fix to 2 decimal places and add '%' to the end.
 * If null, return null.
 * @param value - A number representing a percentage (0-100).
 * @returns A stringified value in this format: .15%
 */
export function formatAsPercentage(value?: number | null) {
  if (value == null) {
    return null
  }
  return `${value.toPrecision(2)}%`
}
